<template>
  <div class="info-box">
    <div class="flex-1 overflow-y-auto gap-x-3">
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
        class="overflow-y-auto px-2.5"
      >
        <ul class="grid gap-x-5" style="grid-template-columns: 1fr auto">
          <el-form-item
            label="姓名"
            prop="name"
            :rules="[
              { required: true, message: '请输入姓名', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item
            label="称谓"
            prop="title"
            :rules="[
              { required: true, message: '请选择称谓', trigger: 'blur' },
            ]"
          >
            <div
              class="rounded px-3 cursor-pointer"
              :class="
                state.model.title == '先生'
                  ? ' bg-green-800 text-white'
                  : ' text-gray-400 border'
              "
              @click="state.model.title = '先生'"
            >
              先生
            </div>
            <div
              class="rounded px-3 ml-2 cursor-pointer"
              :class="
                state.model.title == '女士'
                  ? ' bg-red-600 text-white'
                  : ' text-gray-400 border'
              "
              @click="state.model.title = '女士'"
            >
              女士
            </div>
          </el-form-item>
        </ul>
        <ul class="grid grid-cols-2 gap-x-5">
          <el-form-item
            label="联系电话"
            prop="phone"
            :rules="[
              { required: true, message: '请输入联系电话', trigger: 'blur' },
              { validator: $phone_rules, trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.phone"></el-input>
          </el-form-item>
          <el-form-item label="职务" class="min-w-0">
            <el-input v-model="state.model.job"></el-input>
          </el-form-item>
        </ul>
        <ul class="grid grid-cols-2 gap-x-5">
          <el-form-item
            label="邮箱"
            prop="email"
            :rules="[{ validator: $email_rules, trigger: 'blur' }]"
          >
            <el-input v-model="state.model.email"></el-input>
          </el-form-item>
          <el-form-item label="微信">
            <el-input v-model="state.model.wechat_number"></el-input>
          </el-form-item>
        </ul>
        <el-form-item label="备注">
          <el-input v-model="state.model.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  hotel_contact_detail,
  hotel_contact_add,
  hotel_contact_edit,
} from "@/http/hotel";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
    hotel_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        hotel_id: props.hotel_id,
      },
    });
    onMounted(() => {
      if (props.id) {
        hotel_contact_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data || {};
          }
        });
      }
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            hotel_contact_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            hotel_contact_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
